export const FETCH_INVENTARIO_REQUEST = "FETCH_INVENTARIO_REQUEST";
export const FETCH_INVENTARIO_SUCCESS = "FETCH_INVENTARIO_SUCCESS";
export const FETCH_INVENTARIO_FAILURE = "FETCH_INVENTARIO_FAILURE";

export const FETCH_EQUIPO_ONE_SUCCESS = "FETCH_EQUIPO_ONE_SUCCESS";
export const FETCH_EQUIPO_ONE_FAILURE = "FETCH_EQUIPO_ONE_FAILURE";

export const FETCH_CATEGORIAS_SUCCESS = "FETCH_CATEGORIAS_SUCCESS";
